import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";

export class SalariesSettingsVM extends InterActive{
    private target:string =''
    private cuts:string = ''
    private bounses:string = ''

    public get Target():string { return this.target }
    public get Cuts():string { return this.cuts }
    public get Bounses():string{ return this.bounses }

    public set Target(value:string){ this.target = value; this.update() }
    public set Cuts(value:string){ this.cuts = value; this.update() }
    public set Bounses(value:string){ this.bounses = value; this.update() }

    public getData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getConstants()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.target = response.data.data.target
                                this.cuts = response.data.data.cuts
                                this.bounses = response.data.data.bonuses
                                this.update()
                            }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                }
            }
        )
    }
    public save(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.editConstants({target:this.target , cuts:this.cuts, bounses:this.bounses})
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                Notify({type:'success' , title:'عملية ناجحة' , body:'تم تعديل البيانات بنجاح' })
                                this.update()
                            }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                }
            }
        )
    }

}